import { render } from "./Previewfatturegas.vue?vue&type=template&id=7e14c988&scoped=true"
import script from "./Previewfatturegas.vue?vue&type=script&lang=js"
export * from "./Previewfatturegas.vue?vue&type=script&lang=js"

import "./Previewfatturegas.vue?vue&type=style&index=0&id=7e14c988&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e14c988"]])

export default __exports__